import Vue from 'vue';
import axios from 'axios';
import VueSlideoutPanel from 'vue2-slideout-panel';
import './plugins/bootstrap-vue';
import VCalendar from 'v-calendar';
import VueScrollTo from 'vue-scrollto';
import dayjs from 'dayjs';
import App from './App.vue';
import router from './router';
import store from './store';
import './scss/global.scss';

Vue.use(VueScrollTo);
Vue.use(VueSlideoutPanel);

Vue.config.productionTip = false;
Vue.prototype.$http = axios;

const token = localStorage.getItem('token');
if (token) {
  Vue.prototype.$http.defaults.headers.common.Authorization = `Bearer ${token}`;
}

Vue.prototype.formatDate = date => dayjs(date).format('DD-MM-YYYY');

Vue.use(VCalendar, {
  componentPrefix: 'v',
});

const bus = new Vue();
window.bus = bus;

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    this.$store.dispatch('invoices/getInvoices');
  },
}).$mount('#app');
